import { NgModule } from '@angular/core';

import { AddMomentComponent } from './add-moment/add-moment.component';
import { PageNoteFoundComponent } from './page-note-found/page-note-found.component';
import { HomeComponent } from './home/home.component';



import { RouterModule, Routes } from '@angular/router';


const appRoutes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'add-moment', component: AddMomentComponent, pathMatch: 'full' },
  { path: '**', component: PageNoteFoundComponent, pathMatch: 'full' }
];



@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/app-routing.module.ts